import { getConversationById } from '@app/helpers'

import { ChatState } from '../types'

export const onJoinConversationStart = (
  state: ChatState,
  id: number
): ChatState => {
  const conversation = getConversationById(state.conversations, id)
  if (!conversation) {
    return state
  }

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [id]: {
        ...conversation,
        joining: 'PENDING',
      },
    },
  }
}
